const widthHeightSelector = ({ wh }) => wh;

export default widthHeightSelector;
